// src/components/FeaturesSection.js
import React from "react";
import "./FeaturesSection.css";

const FeaturesSection = () => {
  return (
    <section className="features-section">
      {/* First Section */}
      <div className="feature-row">
        <div className="feature-left light">
          <p>
            La cocina abierta al comedor y al salón crea un ambiente
            <br />
            de amplitud y fluidez en el espacio habitable.
          </p>
        </div>
        <div className="feature-right bold">
          <p>
            Amplitud & <br />
            fluidez
          </p>
        </div>
      </div>

      <div className="row-divider"></div>

      {/* Second Section */}
      <div className="feature-row">
        <div className="feature-left bold">
          <p>
            Sensación de
            <br />
            espacialidad
          </p>
        </div>
        <div className="feature-right light">
          <p>
            Las viviendas incorporan sistemas de apertura de gran formato que
            conectan el estar interior con el espacio exterior, extienden el
            living hacia el frente y conforman un ambiente abierto y flexible.
          </p>
        </div>
      </div>

      <div className="row-divider"></div>

      {/* Third Section */}
      <div className="feature-row">
        <div className="feature-left light">
          <p>
            Diseño y acabados contemporáneos definen un <br />
            proyecto moderno y clásico.
          </p>
        </div>
        <div className="feature-right bold">
          <p>Estilo contemporaneo</p>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
